import React from 'react'
import { Row, Col, Container } from '@kogk/common'
import { ButtonDep as Button, Tag } from '..'
export interface SlimFeatureType {
  html: string
  image: {
    url: string
    alt: string
  }
  imageTag?: string
  link?: {
    text: string
    url: string
  }
  onRenderLink?: () => JSX.Element
}

const SlimFeature = ({ html, image, imageTag, link, onRenderLink }: SlimFeatureType) => {
  if (!image.url) return null

  return (
    <section className='page-slice-spacer'>
      <Container>
        <Row>
          <Col className='col-md-5 pl-0'>
            <div className='d-flex flex-column justify-content-end slim-feature__img w-100'>
              <img alt='' className='image-rounded' src={image.url} />
              {imageTag && (
                <Tag type='imgBlue' className='mb-2 ml-2'>
                  {imageTag}
                </Tag>
              )}
            </div>
          </Col>
          <Col className='pt-0 col-lg-7 pl-0 pl-lg-3'>
            <div className='pt-0'>
              <div dangerouslySetInnerHTML={{ __html: html }} className='mt-2 mb-3' />
              {onRenderLink
                ? onRenderLink()
                : link && (
                    <a href={link.url}>
                      <Button
                        className='d-flex align-items-end'
                        type='secondary'
                        icon='arrowRight'
                        label={link.text}
                      />
                    </a>
                  )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default SlimFeature
